import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Helpers
import clsx from 'clsx';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { header_default_styles } from "../../assets/jss/headerStyles";

const useStyles = makeStyles(header_default_styles);

// USED FOR SCCY OLD DEPRECATED

export default function Header() {
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore(state => state.variant_id);
    const classes = useStyles();
    const actions = useStore(state => state.actions);
    const [isListOpen, setIsListOpen] = React.useState(true)

    const handleVariantChange = (variant_current_id) => {
        // const queryParams = qs.parse(location.search);
        // const newQueries = { variant: variant_current_id, ...queryParams };
        // console.log('newQueries::', newQueries)
        // history.push({ search: qs.stringify(newQueries) });

        actions.setVariant(variant_current_id);
        setIsListOpen(prevState => (!prevState))
    };

    const _toggleList = () => {
        setIsListOpen(prevState => (!prevState))
    }

    const _handleSwatch = (texture) => {
        if(texture === null) {
            return (
                <div className={classes.color_swatch}>
                    <svg viewBox="0 0 48 48">
                        <circle strokeWidth="1" stroke="#666" r="14" fill={"#ffffff"} cy="24" cx="24" className="inner-circle"></circle>
                    </svg>
                </div>
            )            
        } else if(texture.startsWith("#")) {
            return (
                <div className={classes.color_swatch}>
                    <svg viewBox="0 0 48 48" width="48px" height="48px">
                        <circle strokeWidth="1" stroke="#666" r="14" fill={texture} cy="24" cx="24" className="inner-circle"></circle>
                    </svg>
                </div>
            )
        } else if(texture.startsWith("https")) {
            return <div className={classes.image_swatch}><img src={texture} alt="swatch" /></div>
        }
    }

    return (
        <div className={classes.header}>
            <div className={classes.header_wrapper}>
                <div className={classes.title_wrapper}>
                    <section className={classes.main_title}>
                        <h1 className={classes.variantTitle}>{vList[variant_id].title}</h1>
                    </section>
                    <section className={clsx({
                        [classes.variant_switch_section] : true, //always applies
                        [classes.variant_switch_open] : isListOpen
                    })}>
                        <div className={classes.main_variant_wrapper} onClick={_toggleList}>
                            { !isListOpen ? 
                                <div className={classes.triangle_down}><span></span></div> :
                                <div className={classes.triangle_up}><span></span></div>
                            }
                            { !isListOpen && <div className={classes.title_swatch}>{_handleSwatch(vList[variant_id].variant_switch_texture)}</div> } 
                            <div className={classes.main_title_variant}><span>{vList[variant_id].subTitle}</span></div>
                        </div>
                        { isListOpen && (
                            <div className={classes.sub_variant_wrapper}>
                            { Object.keys(vList).map((variant_current_id) => {
                                if(vList[variant_current_id].status === null) return null
                                return (
                                    <div className={clsx({
                                        [classes.clickable_row] : true,
                                        [classes.clickable_row_disabled] : variant_current_id === variant_id
                                    })} onClick={() => handleVariantChange(variant_current_id)} key={variant_current_id}>
                                        <div className={classes.title_swatch}>
                                            {_handleSwatch(vList[variant_current_id].variant_switch_texture)}
                                        </div>
                                        <div className={classes.sub_title_variant}><span>{vList[variant_current_id].subTitle}</span></div>
                                    </div>
                                )
                            })}
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </div>
    );
}